import React from "react";
import "../../../../styles/Pages/Operational/Academic/Programs/Programs.style.css";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";
import { ReactComponent as PlusBtnIcon } from "../../../../assets/Icons/Universal/PlusIcon.svg";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import CrossBtnIcon from "../../../../assets/Icons/Universal/Cross.svg";
import { Form, Formik } from "formik";
import { Helmet } from "react-helmet";
import EventsPreviewCard from "../../../../components/PagesComponents/Operational/Academic/Events/EventsPreviewCard.component";
import Title from "../../../../components/Universal/Title.component";
import AddPeriod from "../../../../components/PagesComponents/Operational/Academic/Events/AddPeriod.component";
import ScrollableModal from "../../../../components/Universal/ScrollableModal.component";
import EventDetails from "../../../../components/PagesComponents/Operational/Academic/Events/EventDetails.component";
const Body = ({
  filter,
  setFilter,
  classesFilter,
  programAddModal,
  setClassesFilter,
  setProgramAddModal,
  subjectInputsContainerCount,
  setSubjectInputsContainerCount,
  eventViewerModal,
  setEventViewerModal,
}) => {
  return (
    <section className="flex-col align-start justify-start g-1 pr-1 pb-1">
      <Helmet>
        <title>Programs</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />
          </div>
        }
      />
      <SecondModal
        isOpen={programAddModal}
        onClose={setProgramAddModal}
        title={"add "}
      >
        <Formik
          initialValues={{
            day: "",
            periods: [],
          }}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ setFieldValue, setTouched, values }) => {
            const removeProgram = (val) => {
              const output = values.periods.filter((data) => {
                return data.id !== val.id;
              });

              setFieldValue("periods", output);
            };
            return (
              <Form>
                <div
                  className="flex-col align-start justify-start g-2 scroll-y pr-1"
                  style={{ width: "50vw", gap: "1.5rem" }}
                >
                  <div className="w-full flex-col align-center justify-center g-3">
                    {/* modal header start  */}
                    <div className="w-full flex-row align-center justify-between">
                      <div className="flex-1 flex-row align-center justify-start g-2">
                        <div className="w-full flex flex-row align-center justify-center">
                          <Title>
                            <span className="t-18 poppins-medium">
                              Add class routine for
                            </span>
                            <span className="color-greenColor t-18 poppins-medium">
                              {" "}
                              class 11/C
                            </span>
                          </Title>
                        </div>
                      </div>
                      <button
                        className="transparentBtn"
                        type="button"
                        onClick={() => setProgramAddModal(false)}
                      >
                        <img
                          src={CrossBtnIcon}
                          alt=""
                          style={{ width: "1rem", height: "1rem" }}
                        />
                      </button>
                    </div>
                    {/* modal header end */}
                    <div className="w-full flex-row align-center justify-center g-1">
                      {[...Array(7)].map((_, index) => {
                        const date = new Date(2021, 0, 3 + index); // Jan 3, 2021 is a Sunday
                        const dayName = date.toLocaleDateString("en-US", {
                          weekday: "long",
                        });

                        // Skip weekends (holidays)
                        if (dayName === "Saturday" || dayName === "Sunday")
                          return null;
                        return (
                          <TogglePushBtn
                            type="radio"
                            setVal={(val) =>
                              setFieldValue("day", val.toLowerCase())
                            }
                            name="day"
                            value={values.programFor}
                            label={dayName}
                            initialBorderColor="#5E4DE1"
                            initialColor="#5E4DE1"
                            checkedBackColor="#5E4DE1"
                            initialBackColor="#E4E0FF"
                            lableStyle={{ fontSize: "14px" }}
                            btnStyle={{ width: "7rem" }}
                          />
                        );
                      })}
                    </div>
                  </div>
                  <hr color="#E5E5E5" />
                  <div className="flex-col align-start justify-start g-1">
                    <div
                      style={{ height: "30vh" }}
                      className="scroll-y flex-col align-start justify-start pr-1"
                    >
                      <div className="flex-col align-start justify-start g-1 h-fit w-full">
                        {values &&
                          values.periods.map((program, index) => (
                            <AddPeriod
                              key={program.id} // Use unique ID as key
                              index={index}
                              program={program}
                              addNewProgram={(updatedProgram) => {
                                const updatedPrograms = [...values.periods];
                                updatedPrograms[index] = updatedProgram;
                                setFieldValue("periods", updatedPrograms);
                              }}
                              removeProgram={removeProgram} // Pass remove function to remove the component
                            />
                          ))}
                        <button
                          type="button"
                          className="transparentBtn flex-row w-fit align-center justify-center g-05"
                          onClick={() => {
                            const newProgram = {
                              id: Date.now(),
                              subject: "",
                              teacher: "",
                              startTime: "",
                              endTime: "",
                            };
                            setFieldValue("periods", [
                              ...values.periods,
                              newProgram,
                            ]);
                          }}
                        >
                          <PlusBtnIcon
                            fill="#6f944e"
                            style={{ width: "2rem", height: "2rem" }}
                          />
                          <span className="t-20 poppins">Add</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="actionBtn w-full p-1">
                    Update
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </SecondModal>

      <ScrollableModal isOpen={eventViewerModal} onClose={setEventViewerModal}>
        <EventDetails />
      </ScrollableModal>

      <div
        className="programsCardSection"
        style={{
          gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))",
        }}
      >
        {[...Array(10)].map((_) => {
          return (
            <EventsPreviewCard
              board="Central Board of Secondary Education (CBSE)"
              affiliation="AICTE, NAAC"
              examMode="Offline/Online"
              path="details"
              id="test"
              onClick={()=>setEventViewerModal(true)}
            />
          );
        })}

        <button
          className="transparentCardBtn radius-10 back-white flex-col align-center justify-center g-1"
          style={{ border: "none" }}
          onClick={() => setProgramAddModal(true)}
        >
          <PlusBtnIcon
            fill="#6f944e"
            style={{ width: "3rem", height: "3rem" }}
          />

          <span className="t-20 weight-bold poppins-medium">Add Events</span>
        </button>
      </div>
    </section>
  );
};

export default Body;
